export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const KEY = '2d6fc87e-ca17-4c19-bcff-c9d49217130e';
export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;